import { render, staticRenderFns } from "./UserMenuDropdown.vue?vue&type=template&id=1ef9d411&scoped=true&"
import script from "./UserMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./UserMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./UserMenuDropdown.vue?vue&type=style&index=0&id=1ef9d411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef9d411",
  null
  
)

export default component.exports